import PlaceholderText from "./PlaceholderText"

export default PlaceholderText